<template>
  <div :class="$attrs.class">
    <component
      :is="form.Field"
      :name="name"
      :class="$attrs.class"
      :validators="validators"
    >
      <template #default="formProps">
        <FormSelect
          :id="id"
          ref="selectRef"
          :model-value="formProps.field.state.value"
          :label="label"
          :disabled="disabled"
          :required="!!required"
          :error="formProps.field.state.meta.errors?.[0]?.message"
          :autocomplete="autocomplete"
          @update:model-value="
            (value) => {
              formProps.field.handleChange(value)
              formProps.field.handleBlur()
            }
          "
        >
          <slot></slot>
        </FormSelect>
      </template>
    </component>
  </div>
</template>

<script setup lang="ts">
import type { z } from 'zod'
import FormSelect from '~/components/common/form/FormSelect.vue'

defineProps<{
  form: any // The form instance from @tanstack/vue-form
  name: string
  label?: string
  disabled?: boolean
  id?: string
  required?: boolean
  autocomplete?: string
  validators?: Record<string, z.ZodType<any>>
}>()

const selectRef = ref<InstanceType<typeof FormSelect> | null>(null)

defineExpose({
  selectRef,
  focusSelect: () => {
    if (selectRef.value) {
      selectRef.value.focusSelect()
    }
  },
})
</script>
